<template>
    <div>
        <rkm-table
            :fields="fields"
            :items="data.model.prioridade"
            sort-by="nome"
        >
            <template v-slot:cell(actions)="{ item }">
                <rkm-button
                    @click="$refs.Modal.open(item)"
                    color="primary"
                    small
                    title="Editar"
                >
                    <rkm-icon icon="pen" />
                </rkm-button>

                <rkm-button
                    :disabled="item.allowDestroy && item.id != null || slaPrioridadeIds(item.id)"
                    @click="destroy(item)"
                    color="danger"
                    small
                    title="Excluir"
                >
                    <rkm-icon icon="trash" />
                </rkm-button>
            </template>
        </rkm-table>

        <Modal
            :data="data"
            ref="Modal"
        />
    </div>
</template>

<script>

// Components.
import Modal from './Modal'

export default {
    components: { Modal },
    data: () => ({
        fields: [
            { key: 'nomePrioridade', label: 'Nome', sortable: true },
            { key: 'tipoPrioridadeNome', label: 'Tipo', sortable: true },
            { key: 'actions', label: 'Ações', class: 'col-min text-center' },
        ],
    }),
    methods: {
        destroy(prioridade) {

            this.showDeleteConfirmation(
                'Deseja realmente excluir a prioridade?',
                async () => this.data.model.prioridade.splice(this.data.model.prioridade.indexOf(prioridade), 1)
            )
        },
        slaPrioridadeIds(prioridade) {

            const exists = this.sla.some(item => item.prioridadeId === prioridade);
            return exists;
        },
    },
    props: {
        data: { type: Object, required: true },
        sla: { type: [Array, Object], required: true },
    },
}
</script>